import superagent from 'superagent';
import qs from 'qs';

const methods = ['get', 'post', 'delete', 'put', 'patch'];

export default class ApiClient {

	constructor(apiHost, mlsApiHost, clientId) {
		this.clientid = clientId;
		methods.forEach(method =>
			this[method] = (path, {params = {}, data, headers} = {}) => {
				const host = path.indexOf('mls-connection') !== -1 || path.indexOf('agent-mls-ids') !== -1
					? mlsApiHost : apiHost;
				return this.handleCall(method, host + path, params, data, headers);
			});
	}

	handleCall(method, path, params, data, headers) {
		return new Promise((resolve, reject) => {
			const request = superagent[method](path).withCredentials();
			const { clientid } = this;

			if (params) {
				request.query(qs.stringify(params));
			}

			request.set('Accept', 'application/json');
			// Add cache control to avoid problems in IE 11 and older
			request.set('Cache-Control', 'private, no-cache, no-store, must-revalidate');
			request.set('Expires', '0');
			request.set('Pragma', 'no-cache');
			request.set('clientid', clientid);

			for (const header in headers) {
				if (headers.hasOwnProperty(header)) {
					request.set(header, headers[header]);
				}
			}

			if (data) {
				request.send(data);
			}

			request.end((err, res = {}) => {
				if (err) {
					err.statusCode = res.statusCode;
				}

				return err ? reject(err) : resolve(res.body);
			});
		});
	}

}



// WEBPACK FOOTER //
// ./src/lib/ApiClient.js